/* @flow */

import * as React from 'react';

import {LoadingIcon} from 'shells/icon';
import {PlugErrorState} from 'shells/illustrations';
import {StackLegacy} from 'shells/layout';

import type {MonthlyUsage} from '../../limits/get-usage-from-limits';

import type {PowerAiVariant} from './ai-usage-popover';

import './power-ai-usage-popover.module.css';

export const getUsageVerbage = (monthlyUsage: ?MonthlyUsage) => {
    const summarizationVerbage =
        monthlyUsage && monthlyUsage.remaining === 1 ? 'summary' : 'summaries';

    return summarizationVerbage;
};

export const generateTitleBody = (variant: PowerAiVariant) => {
    switch (variant) {
        case 'timeline':
            return {
                title: 'Summarize this timeline',
                body: (
                    <>
                        Nutshell uses AI to analyze your timeline interactions and provide you with
                        a brief summary.
                    </>
                ),
            };
        case 'zoom':
        default:
            return {
                title: 'Summarize this transcription',
                body: (
                    <>
                        Nutshell uses AI to generate a brief summary of your Zoom meeting
                        transcriptions.
                    </>
                ),
            };
    }
};

export const getLimitsContent = (
    isLoading: boolean,
    monthlyUsage: ?MonthlyUsage,
    error?: boolean
) => {
    if (isLoading) {
        return (
            <div className='flex justify-center'>
                <LoadingIcon size={24} />
            </div>
        );
    }

    if (monthlyUsage) {
        return (
            <div>
                Your team has <strong>{monthlyUsage.remaining.toLocaleString()}</strong>{' '}
                {getUsageVerbage(monthlyUsage)} left out of{' '}
                <strong>
                    {monthlyUsage.limit ? monthlyUsage.limit.toLocaleString() : 'unlimited'}
                </strong>{' '}
                per month.
            </div>
        );
    }

    if (error) {
        return (
            <StackLegacy spacing={8} isHorizontal={true} alignCenter={true}>
                <div styleName='error-svg-container'>
                    <PlugErrorState />
                </div>
                <div>Something went wrong fetching this response. Try again in a bit!</div>
            </StackLegacy>
        );
    }

    return null;
};
